<template>

    <div v-if="!$auth.loading" class=" mt-10">

        <div v-if="!isAuthenticated" class="myCenter"> 
        
            <div  class="flex flex-col">
    
                <div class="my-btn my-btn-pink my-text-mobile flex">
                    
                    <svg class="w-8 h-8 fill-current text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                    
                        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4s-4 1.79-4 4s1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/><rect x="0" y="0" width="24" height="24" fill="rgba(0, 0, 0, 0)" />
                    </svg>

                    <div>
                        <!-- <input/> -->
                    </div>
                    <div v-if="!isAuthenticated" class="w-full">

                        <button v-if="!key" @click="login" >{{$t('home.login')}}</button>

                        <button v-if="key" @click="autoSign">{{$t('home.loginAgain')}}</button>
                    </div>

                    <!-- <div v-if="isAuthenticated" class="w-full">
                        
                        <button @click="logout">{{$t('home.logOut')}}</button>
                    </div> -->
                </div>
            </div>  
        </div>
            
        <div v-else class="flex flex-col justify-center items-center text-white
        lg:text-2xl text-xl text-center w-full lg:m-5 lg:rounded-l-full rounded-t-lg">

            <label class="bg-blue-400 border p-4 lg:p-8 lg:rounded-full text-lg rounded-lg w-1/2">{{$t('home.welcomeToPnadi')}}</label>
        </div>

        <div class="myCenter mt-10">

            <div class="w-32 h-32 lg:w-64 lg:h-64 bg-white rounded-lg bg mb-10  shadow-xs py-2"> 

                <img class="" src="@/assets/images/only-logo.jpg"/>
            </div>
        </div>


    </div>    
</template>

<script>

import componentsHelpers from '../../classes/componentHelpers';

import { CircleLoader } from 'vue-spinners-css';

import moment from 'moment';

export default {

     async mounted(){

         try{

            this.loader = true;

            let result = await this.$auth.isAuthenticated();
            this.isAuthenticated = result;
            this.loader = false;
            const todayDate = moment(new Date()).format(moment.HTML5_FMT.DATE); 

            if(!this.isAuthenticated){
                
                if (this.key != null && this.key != '')
                {

                    // console.log(`before lastReloginRedirect`);

                    if(localStorage.hasOwnProperty('lastReloginRedirect')){


                    // console.log(`after lastReloginRedirect: ${localStorage.getItem('lastReloginRedirect')}`);

                        const dayDate = localStorage.getItem('lastReloginRedirect');

                        if(todayDate == dayDate){

                            return;
                        }else{

                            localStorage.setItem('lastReloginRedirect', todayDate);

                            await this.$auth.login();
                        }
                    }else{

                        localStorage.setItem('lastReloginRedirect', todayDate);
                    }
                }
            }
                    
         }catch(e){
            
            this.loader = false;
            this.isAuthenticated = false;

            componentsHelpers.sendError(this.$apollo, 0,'Home', 'Login', 'Mounted', e);

            componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
         }
    },

    computed:{
 
    },

    props: {

        reloadAfterLogout: Function
    },

    components: {

        CircleLoader
    },

    methods: {
        // Log the user in
       async login() {
            //this.$auth.loginWithRedirect();

            try{
                
                this.loader = true;
                await this.$auth.login();
                this.loader = false;
            }catch(e){

                this.loader = false;

                // console.log(` error is ${e}`);
                // return;
                componentsHelpers.sendError(this.$apollo, 0,'Home', 'Login', 'login', e);
                
                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);

                
            }
        },

       async autoSign(){

                await this.$auth.login();
        },
        async logout() {
                   

            try{

            await this.$apollo.provider.defaultClient.resetStore();
            
            }catch(e){

                componentsHelpers.sendError(this.$apollo, 0,'Home', 'Login', 'logOut', JSON.stringify(e));
    
                componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
            }

            await this.$auth.logout();

        this.reloadAfterLogout();
        },

    },

  data:function() {

      return {
        
          loader: false,
          isAuthenticated: false,
          key: localStorage.getItem('for_pnadi') !== '' ? localStorage.getItem('for_pnadi') : '',
          isPinkStyle: true
        };
    },

    watch: {
        '$isPinkStyle'(newValue) {
            
            this.isPinkStyle = newValue;
            }
        }
}
</script>

<style>

</style>